export default __webpack_public_path__ + "static/media/search.4aed31fb.jpeg";